import { Vote, Crown, Check } from "lucide-react";
import { CategoryIcon } from "./CategoryIcon";

function VoteOption({ stopType, option, index, count, pct, mine, leader, planned, disabled, onSelect }) {
  return (
    <button
      data-testid={`vote-option-${stopType}-${index}`}
      disabled={disabled}
      onClick={onSelect}
      className={`relative overflow-hidden rounded-xl border px-4 py-3 text-left transition-colors ${
        mine ? "border-accent ring-1 ring-accent" : "border-border hover:border-primary/50"
      } bg-card disabled:opacity-70`}
    >
      <span className="absolute inset-y-0 left-0 bg-primary/15 transition-[width] duration-500" style={{ width: `${pct}%` }} />
      <span className="relative flex items-center gap-3">
        <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-secondary">
          <CategoryIcon name={option.icon} size={16} />
        </span>
        <span className="min-w-0 flex-1">
          <span className="flex items-center gap-2">
            <span className="truncate font-semibold">{option.name}</span>
            {planned && (
              <span className="rounded-full bg-secondary px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-muted-foreground">
                Planned
              </span>
            )}
            {leader && <Crown size={14} className="text-amber-400 shrink-0" data-testid={`vote-leader-${stopType}-${index}`} />}
          </span>
          <span className="block truncate text-xs text-muted-foreground">{option.category_label}</span>
        </span>
        <span className="flex items-center gap-2 text-sm font-bold" data-testid={`vote-count-${stopType}-${index}`}>
          {count}
          {mine && <Check size={15} className="neon-cyan" />}
        </span>
      </span>
    </button>
  );
}

export function VotePanel({ stopType, options, tallies, myVote, onVote, voting, plannedIndex = 0 }) {
  if (!options || options.length < 2) return null;
  const counts = tallies || options.map(() => 0);
  const total = counts.reduce((a, b) => a + b, 0);
  const max = Math.max(...counts);
  const label = stopType === "dinner" ? "Where should we eat?" : "Where should we drink?";

  return (
    <div data-testid={`vote-panel-${stopType}`} className="rounded-2xl border border-dashed border-border bg-secondary/30 p-5">
      <div className="flex items-center justify-between gap-3">
        <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-muted-foreground">
          <Vote size={14} className="neon-cyan" /> Group vote · {label}
        </span>
        <span className="text-xs text-muted-foreground" data-testid={`vote-total-${stopType}`}>
          {total} {total === 1 ? "vote" : "votes"}
        </span>
      </div>
      <div className="mt-3 grid gap-2">
        {options.map((opt, i) => (
          <VoteOption
            key={`${stopType}-${opt.name}`}
            stopType={stopType}
            option={opt}
            index={i}
            count={counts[i] || 0}
            pct={total ? Math.round(((counts[i] || 0) / total) * 100) : 0}
            mine={myVote === i}
            leader={total > 0 && counts[i] === max}
            planned={i === plannedIndex}
            disabled={voting}
            onSelect={() => onVote(stopType, i)}
          />
        ))}
      </div>
    </div>
  );
}
